import { useEffect, useState } from "react";
import API from "../services/api";
import { useNavigate } from "react-router-dom";
import StudentForm from "../components/students/StudentForm";


export default function Students() {

    const [students, setStudents] = useState([]);

    const [searchAdmission, setSearchAdmission] = useState("");

    const [searchName, setSearchName] = useState("");

    const [searchMobile, setSearchMobile] = useState("");

    const [searchClass, setSearchClass] = useState("");
    const navigate = useNavigate();

    const [searchSection, setSearchSection] = useState("");

    const [search, setSearch] = useState("");

    const [classFilter, setClassFilter] = useState("");

    const [sectionFilter, setSectionFilter] = useState("");

    const [selectedStudent, setSelectedStudent] = useState(null);

    const [showViewModal, setShowViewModal] = useState(false);

    const [showEditModal, setShowEditModal] = useState(false);

    const [errors, setErrors] = useState({});

    const [currentPage, setCurrentPage] = useState(1);
    const [sortBy, setSortBy] = useState("admission");

    const [studentsPerPage, setStudentsPerPage] = useState(10);

    const [form, setForm] = useState({

        admission_date: new Date().toISOString().split("T")[0],

        academic_year: "",

        status: "Active",

        name: "",

        dob: "",

        gender: "",

        blood_group: "",

        aadhaar_no: "",

        className: "",

        section: "A",

        roll_no: "",

        father_name: "",

        mother_name: "",

        guardian_name: "",

        parent_mobile: "",

        alternate_mobile: "",

        parent_email: "",

        emergency_contact: "",

        address: "HighCourt Colony Vanasthalipuram",
        city: "Hyderabad",
        state: "Telangana",
        pincode: "501505"

    });

    useEffect(() => {
        fetchStudents();
        fetchActiveAcademicYear();
    }, []);

    const fetchStudents = async () => {

        try {

            const res = await API.get("/students");

            setStudents(res.data);

        } catch (err) {

            alert("Unable to fetch students");
        }
    };

    const fetchActiveAcademicYear = async () => {

        try {

            const res = await API.get(
                "/settings/active-academic-year"
            );

            setForm(prev => ({

                ...prev,

                academic_year: res.data.academic_year

            }));

        }

        catch (err) {

            console.log(err);

        }

    };

    /* =========================
       ADD STUDENT
    ========================= */

    const handleAddStudent = async () => {

        const newErrors = {};

        const missingFields = [];

        if (!form.name.trim()) {
            newErrors.name = true;
            missingFields.push("Student Name");
        }

        if (!form.dob) {
            newErrors.dob = true;
            missingFields.push("Date of Birth");
        }

        if (!form.gender) {
            newErrors.gender = true;
            missingFields.push("Gender");
        }

        if (!form.className) {
            newErrors.className = true;
            missingFields.push("Class");
        }

        if (!form.section) {
            newErrors.section = true;
            missingFields.push("Section");
        }
        if (!form.section) {
            newErrors.section = true;
            missingFields.push("father_name");
        }

        if (!form.address.trim()) {
            newErrors.address = true;
            missingFields.push("Address");
        }

        if (!form.city.trim()) {
            newErrors.city = true;
            missingFields.push("City");
        }

        if (!form.state.trim()) {
            newErrors.state = true;
            missingFields.push("State");
        }

        if (!form.pincode.trim()) {
            newErrors.pincode = true;
            missingFields.push("PIN Code");
        }


        setErrors(newErrors);

        if (missingFields.length > 0) {

            alert(
                `Please complete mandatory fields:

• ${missingFields.join("\n• ")}`
            );

            return;
        }

        try {

            const res = await API.post(
                "/students/add",
                form
            );

            alert(
                `🎉 Admission Completed Successfully

Admission Number: ${res.data.admission_no}`
            );

            setForm({

                name: "",
                dob: "",
                gender: "",

                className: "",
                section: "",

                father_name: "",
                mother_name: "",

                parent_mobile: "",
                emergency_contact: "",

                address: ""
            });

            setErrors({});

            fetchStudents();
            fetchActiveAcademicYear();

        } catch (err) {

            console.log(err);

            console.log(err.response);

            console.log(err.response?.data);

            alert(

                err.response?.data?.msg ||

                err.response?.data?.message ||

                err.message ||

                "Unable to add student"

            );

        }
    };

    /* =========================
       DELETE STUDENT
    ========================= */

    const handleDeleteStudent = async (id) => {

        const confirmDelete = window.confirm(
            "Are you sure you want to delete this student?"
        );

        if (!confirmDelete) return;

        try {

            await API.delete(
                `/students/delete/${id}`
            );

            alert("Student deleted successfully");

            fetchStudents();

        } catch (err) {

            alert("Unable to delete student");
        }
    };

    /* =========================
       UPDATE STUDENT
    ========================= */

    const handleUpdateStudent = async () => {

        try {

            const payload = {

                name: selectedStudent.name,
                dob: selectedStudent.dob,
                gender: selectedStudent.gender,

                className: selectedStudent.class,
                section: selectedStudent.section,

                father_name: selectedStudent.father_name,
                mother_name: selectedStudent.mother_name,

                parent_mobile: selectedStudent.parent_mobile,
                emergency_contact: selectedStudent.emergency_contact,

                address: selectedStudent.address
            };

            await API.put(
                `/students/update/${selectedStudent.id}`,
                payload
            );

            alert("Student updated successfully");

            setShowEditModal(false);

            fetchStudents();

        } catch (err) {

            console.log(err);

            alert("Unable to update student");
        }
    };



    /* =========================
       FILTER STUDENTS
    ========================= */

    const filteredStudents = students.filter(student => {

        return (

            student.admission_no
                ?.toLowerCase()
                .includes(searchAdmission.toLowerCase())

            &&

            student.name
                ?.toLowerCase()
                .includes(searchName.toLowerCase())

            &&

            student.parent_mobile
                ?.toLowerCase()
                .includes(searchMobile.toLowerCase())

            &&

            (searchClass === "" ||
                student.class === searchClass)

            &&

            (searchSection === "" ||
                student.section === searchSection)

        );

    });

    const indexOfLastStudent = currentPage * studentsPerPage;

    const indexOfFirstStudent =
        indexOfLastStudent - studentsPerPage;

    const sortedStudents = [...filteredStudents];

    switch (sortBy) {

        case "name":

            sortedStudents.sort((a, b) =>
                a.name.localeCompare(b.name)
            );

            break;

        case "class":

            sortedStudents.sort((a, b) => {

                if (a.class === b.class) {

                    return a.section.localeCompare(b.section);

                }

                return a.class.localeCompare(b.class);

            });

            break;

        case "balance":

            sortedStudents.sort(

                (a, b) =>

                    Number(b.balance) -

                    Number(a.balance)

            );

            break;

        default:

            sortedStudents.sort(

                (a, b) =>

                    a.admission_no.localeCompare(b.admission_no)

            );

    }

    const currentStudents = sortedStudents.slice(

        indexOfFirstStudent,

        indexOfLastStudent

    );

    const totalPages = Math.ceil(
        filteredStudents.length / studentsPerPage
    );

        // your functions
        const totalStudents = students.length;

        const fullyPaid = students.filter(
            s => s.fee_status === "Paid"
        ).length;

        const partialStudents = students.filter(
            s => s.fee_status === "Partial"
        ).length;

        const dueStudents = students.filter(
            s => s.fee_status === "Not Started"
        ).length;

        const outstandingAmount = students.reduce(
            (sum, s) => sum + Number(s.balance || 0),
            0
        );

       

    return (

        <div className="p-3 sm:p-4 lg:p-6 bg-gray-100 min-h-screen">
            
            {/* HEADER */}
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 mb-6 lg:mb-8">

                <div>

                    <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-800">
                        Student Admission
                        
                    </h1>
                    {/*<StudentForm />*/}

                    {/*<p className="text-gray-500 mt-2">*/}
                    {/*    Admissions • Register a new student...*/}
                    {/*</p>*/}

                </div>

              

                {/* ===========================
                   FINANCE SUMMARY
                =========================== */}

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 sm:gap-5 mb-6 lg:mb-8">

                    <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-2xl shadow-lg p-5">

                        <p className="text-sm opacity-90">
                            Total Students
                        </p>

                        <h2 className="text-3xl font-bold mt-2">
                            {totalStudents}
                        </h2>

                    </div>



                    <div className="bg-gradient-to-r from-green-600 to-green-700 text-white rounded-2xl shadow-lg p-5">

                        <p className="text-sm opacity-90">
                            Fully Paid
                        </p>

                        <h2 className="text-3xl font-bold mt-2">
                            {fullyPaid}
                        </h2>

                    </div>



                    <div className="bg-gradient-to-r from-yellow-500 to-orange-500 text-white rounded-2xl shadow-lg p-5">

                        <p className="text-sm opacity-90">
                            Partial
                        </p>

                        <h2 className="text-3xl font-bold mt-2">
                            {partialStudents}
                        </h2>

                    </div>



                    <div className="bg-gradient-to-r from-red-600 to-red-700 text-white rounded-2xl shadow-lg p-5">

                        <p className="text-sm opacity-90">
                            Payment Due
                        </p>

                        <h2 className="text-3xl font-bold mt-2">
                            {dueStudents}
                        </h2>

                    </div>



                    {/*<div className="bg-gradient-to-r from-purple-700 to-indigo-700 text-white rounded-2xl shadow-lg p-5">*/}

                    {/*    <p className="text-sm opacity-90">*/}
                    {/*        Outstanding Fees*/}
                    {/*    </p>*/}

                    {/*    <h2 className="text-2xl font-bold mt-2">*/}

                    {/*        ₹{outstandingAmount.toLocaleString()}*/}

                    {/*    </h2>*/}

                    {/*</div>*/}

                </div>

            </div>

            {/* ADD STUDENT */}
            <div className="bg-white rounded-3xl shadow-2xl p-4 sm:p-6 lg:p-8 mb-6 lg:mb-8">

                <h2 className="text-2xl sm:text-3xl font-bold mb-6 lg:mb-8">
                    New Admission...
                </h2>

     {/* ======================================
           ADMISSION INFORMATION
        ====================================== */}

                <div className="bg-blue-50 border border-blue-200 rounded-2xl p-4 sm:p-6 mb-6 lg:mb-8">

                    <h3 className="text-xl font-bold text-blue-800 mb-5">
                        Admission Information
                    </h3>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">

                        {/* Admission No */}

                        <div>

                            <label className="block mb-2 font-semibold">
                                Admission No
                            </label>

                            <input

                                value="Auto Generated"

                                disabled

                                className="border rounded-2xl p-4 w-full bg-gray-100"

                            />

                        </div>

                        {/* Admission Date */}

                        <div>

                            <label className="block mb-2 font-semibold">
                                Admission Date
                            </label>

                            <input

                                type="date"

                                value={form.admission_date}

                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        admission_date: e.target.value
                                    })
                                }

                                className={`border rounded-2xl p-4 w-full ${errors.address ? "border-red-500" : ""
                                    }`}

                            />

                        </div>

                        {/* Academic Year */}

                        <div>

                            <label className="block mb-2 font-semibold">
                                Academic Year
                            </label>

                            <input

                                value={form.academic_year}

                                readOnly

                                className="border rounded-2xl p-4 w-full bg-gray-100 cursor-not-allowed"

                            />

                        </div>

                        {/* Status */}

                        <div>

                            <label className="block mb-2 font-semibold">
                                Status
                            </label>

                            <select

                                value={form.status}

                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        status: e.target.value
                                    })
                                }

                                className={`border rounded-2xl p-4 w-full ${errors.state ? "border-red-500" : ""
                                    }`}

                            >

                                <option>Active</option>

                                <option>Inactive</option>

                            </select>

                        </div>

                    </div>

                </div>

                <div className="bg-blue-50 border border-blue-200 rounded-2xl p-6 mb-8">

                    <h3 className="text-xl font-bold text-blue-800 mb-5">
                        Student Information
                    </h3>

                

                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5">


                    {/* NAME */}
                    <div>

                        <label className="block mb-2 font-semibold">
                            Student Name *
                        </label>

                        <input
                            value={form.name}
                            onChange={(e) =>
                                setForm({
                                    ...form,
                                    name: e.target.value
                                })
                            }
                            className={`border rounded-2xl p-4 w-full ${errors.name
                                    ? "border-red-500"
                                    : ""
                                }`}
                        />

                    </div>

                    {/* DOB */}
                    <div>

                        <label className="block mb-2 font-semibold">
                            Date of Birth *
                        </label>

                        <input
                            type="date"
                            value={form.dob}
                            onChange={(e) =>
                                setForm({
                                    ...form,
                                    dob: e.target.value
                                })
                            }
                            className={`border rounded-2xl p-4 w-full ${errors.dob
                                    ? "border-red-500"
                                    : ""
                                }`}
                        />

                    </div>

                    {/* GENDER */}
                    <div>

                        <label className="block mb-2 font-semibold">
                            Gender *
                        </label>

                        <select
                            value={form.gender}
                            onChange={(e) =>
                                setForm({
                                    ...form,
                                    gender: e.target.value
                                })
                            }
                            className={`border rounded-2xl p-4 w-full ${errors.gender
                                    ? "border-red-500"
                                    : ""
                                }`}
                        >

                            <option value="">
                                Select Gender
                            </option>

                            <option value="Male">
                                Male
                            </option>

                            <option value="Female">
                                Female
                            </option>

                        </select>

                    </div>

                    {/* BLOOD GROUP */}

                    <div>

                        <label className="block mb-2 font-semibold">
                            Blood Group
                        </label>

                        <select
                            value={form.blood_group}
                            onChange={(e) =>
                                setForm({
                                    ...form,
                                    blood_group: e.target.value
                                })
                            }
                            className="border rounded-2xl p-4 w-full"
                        >

                            <option value="">Select</option>

                            <option>A+</option>
                            <option>A-</option>
                            <option>B+</option>
                            <option>B-</option>
                            <option>AB+</option>
                            <option>AB-</option>
                            <option>O+</option>
                            <option>O-</option>

                        </select>

                    </div>

                    {/* AADHAAR */}

                    <div>

                        <label className="block mb-2 font-semibold">
                            Aadhaar Number
                        </label>

                        <input

                            type="text"

                            maxLength={12}

                            value={form.aadhaar_no}

                            onChange={(e) => {

                                const numbers =
                                    e.target.value.replace(/\D/g, "");

                                setForm({

                                    ...form,

                                    aadhaar_no: numbers

                                });

                            }}

                            placeholder="12 digit Aadhaar"

                            className="border rounded-2xl p-4 w-full"

                        />

                    </div>

                    {/* CLASS */}
                    <div>

                        <label className="block mb-2 font-semibold">
                            Class *
                        </label>

                        <select
                            value={form.className}
                            onChange={(e) =>
                                setForm({
                                    ...form,
                                    className: e.target.value
                                })
                            }
                            className={`border rounded-2xl p-4 w-full ${errors.className
                                    ? "border-red-500"
                                    : ""
                                }`}
                        >

                            <option value="">
                                Select Class
                            </option>

                            {[
                                "PP1",
                                "PP2",
                                "LKG",
                                "UKG",
                                "1",
                                "2",
                                "3",
                                "4",
                                "5",
                                "6",
                                "7",
                                "8",
                                "9",
                                "10",
                                "11",
                                "12"
                            ].map((cls) => (

                                <option
                                    key={cls}
                                    value={cls}
                                >
                                    {cls}
                                </option>
                            ))}

                        </select>

                    </div>

                    {/* SECTION */}
                    <div>

                        <label className="block mb-2 font-semibold">
                            Section *
                        </label>

                        <select
                            value={form.section}
                            onChange={(e) =>
                                setForm({
                                    ...form,
                                    section: e.target.value
                                })
                            }
                            className={`border rounded-2xl p-4 w-full ${errors.section
                                    ? "border-red-500"
                                    : ""
                                }`}
                        >

                            <option value="">
                                Select Section
                            </option>

                            {"ABCDEFGHIJKLMNOPQRSTUVWXYZ"
                                .split("")
                                .map((letter) => (
                                    <option
                                        key={letter}
                                        value={letter}
                                    >
                                        {letter}
                                    </option>
                                ))}

                        </select>

                    </div>

                    {/* FATHER */}
                    <div>

                        <label className="block mb-2 font-semibold">
                            Father Name
                        </label>

                        <input
                            value={form.father_name}
                            onChange={(e) =>
                                setForm({
                                    ...form,
                                    father_name: e.target.value
                                })
                            }
                            className={`border rounded-2xl p-4 w-full ${errors.name
                                ? "border-red-500"
                                : ""
                                }`}
                        />

                    </div>

                    {/* MOTHER */}
                    <div>

                        <label className="block mb-2 font-semibold">
                            Mother Name
                        </label>

                        <input
                            value={form.mother_name}
                            onChange={(e) =>
                                setForm({
                                    ...form,
                                    mother_name: e.target.value
                                })
                            }
                            className={`border rounded-2xl p-4 w-full ${errors.name
                                ? "border-red-500"
                                : ""
                                }`}
                        />

                    </div>

                    {/* GUARDIAN */}

                    <div>

                        <label className="block mb-2 font-semibold">
                            Guardian Name
                        </label>

                        <input

                            value={form.guardian_name}

                            onChange={(e) =>
                                setForm({
                                    ...form,
                                    guardian_name: e.target.value
                                })
                            }

                            className="border rounded-2xl p-4 w-full"

                        />

                    </div>

                    {/* MOBILE */}
                    <div>

                        <label className="block mb-2 font-semibold">
                            Parent Mobile
                        </label>

                        <input
                            type="text"
                            placeholder="Enter 10-digit mobile number"
                            value={form.parent_mobile}
                            maxLength={10}
                            onChange={(e) => {

                                const onlyNumbers =
                                    e.target.value.replace(/\D/g, "");

                                setForm({
                                    ...form,
                                    parent_mobile: onlyNumbers
                                });
                            }}
                            className={`border rounded-2xl p-4 w-full ${errors.name
                                ? "border-red-500"
                                : ""
                                }`}
                        />

                    </div>

                    {/* PARENT EMAIL */}

                    <div>

                        <label className="block mb-2 font-semibold">
                            Parent Email
                        </label>

                        <input

                            type="email"

                            value={form.parent_email}

                            onChange={(e) =>
                                setForm({
                                    ...form,
                                    parent_email: e.target.value
                                })
                            }

                            className="border rounded-2xl p-4 w-full"

                        />

                    </div>

                    {/* Emergency Contact */}
                    <div>

                        <label className="block mb-2 font-semibold">
                            Emergency Contact
                        </label>

                        <input
                            type="text"
                            placeholder="Enter emergency contact number"
                            value={form.emergency_contact}
                            maxLength={10}
                            onChange={(e) => {

                                const onlyNumbers =
                                    e.target.value.replace(/\D/g, "");

                                setForm({
                                    ...form,
                                    emergency_contact: onlyNumbers
                                });
                            }}
                            className="border rounded-2xl p-4 w-full"
                        />

                        </div>
                    </div>

                <div>
                        <br />
                </div>


                    <div className="bg-blue-50 border border-blue-200 rounded-2xl p-6 mb-8">

                        <h3 className="text-xl font-bold text-blue-800 mb-5">
                            Address Information
                        </h3>

                  

                    {/* CITY */}

                    <div>

                        <label className="block mb-2 font-semibold">
                            City
                        </label>

                        <input

                            value={form.city}

                            onChange={(e) =>
                                setForm({
                                    ...form,
                                    city: e.target.value
                                })
                            }

                                className={`border rounded-2xl p-4 w-full ${errors.address ? "border-red-500" : ""
                                    }`}

                        />

                    </div>

                    {/* STATE */}

                    <div>

                        <label className="block mb-2 font-semibold">
                            State
                        </label>

                        <input

                            value={form.state}

                            onChange={(e) =>
                                setForm({
                                    ...form,
                                    state: e.target.value
                                })
                            }

                                className={`border rounded-2xl p-4 w-full ${errors.address ? "border-red-500" : ""
                                    }`}

                        />

                    </div>

                    {/* PINCODE */}

                    <div>

                        <label className="block mb-2 font-semibold">
                            PIN Code
                        </label>

                        <input

                            maxLength={6}

                            value={form.pincode}

                            onChange={(e) => {

                                const numbers =
                                    e.target.value.replace(/\D/g, "");

                                setForm({

                                    ...form,

                                    pincode: numbers

                                });

                            }}

                                className={`border rounded-2xl p-4 w-full ${errors.address ? "border-red-500" : ""
                                    }`}

                        />

                    </div>


                    {/* ADDRESS */}
                    <div className="md:col-span-2">

                        <label className="block mb-2 font-semibold">
                            Address
                        </label>

                        <textarea
                            rows="3"
                            value={form.address}
                            onChange={(e) =>
                                setForm({
                                    ...form,
                                    address: e.target.value
                                })
                            }
                                className={`border rounded-2xl p-4 w-full ${errors.address ? "border-red-500" : ""
                                    }`}
                        />

                    </div>

                    </div>
                </div>


                <button
                    onClick={handleAddStudent}
                    className="mt-8 bg-blue-700 hover:bg-blue-800 text-white px-8 py-4 rounded-2xl font-bold"
                >
                    Complete Admission
                </button>

            </div>

         

           

        </div>
    );
}